export default __webpack_public_path__ + "static/media/ibrahin_1.837de868.jpg";